import __request__ from "routing/request";
export function getPage(streamId, sort = "rule", page = 1, per_page = 50, query, filters, order = "asc") {
  return __request__("GET", `/routing_rules/paginated/${streamId}`, null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
